import parsePhoneNumberFromString from 'libphonenumber-js';
import * as Yup from 'yup';

export interface IAddGuarantorCreateForm {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  doctorCode: string;
}

export const initialValues: IAddGuarantorCreateForm = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  doctorCode: '',
};

const emailValidation = Yup.string().required('validation.required').email('validation.email');
const phoneValidation = Yup.string().test(
  'phone-country',
  'validation.phone_format',
  function (v: any) {
    if (v && v.length !== 4) {
      const phone = parsePhoneNumberFromString(v);
      return phone?.isValid() || false;
    }
    return true;
  },
);

export const validationSchema = Yup.object().shape({
  email: emailValidation,
  phoneNumber: phoneValidation,
  firstName: Yup.string().required('validation.required'),
  lastName: Yup.string().required('validation.required'),
  doctorCode: Yup.string().required('validation.required'),
});
